import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Clock, ArrowRight } from 'lucide-react';
import SEO, { generateBreadcrumbSchema } from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { guides } from '../data/guides';

const Guides = () => (
  <div className="min-h-screen bg-slate-50" data-testid="guides-page">
    <SEO title="Motorhome Touring Guides: Suffolk & Essex Routes, Campsites & Tips" rawTitle
      description="Free motorhome holiday guides from Millie's Motorhome Hire - Suffolk coast routes, the best campsites in Suffolk and Essex, first-time hirer tips, travelling with dogs and choosing the right motorhome."
      url="/guides" structuredData={generateBreadcrumbSchema([{ name: 'Guides', path: '/guides' }])} />
    <section className="bg-slate-900 text-white py-14">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-6"><Breadcrumbs light items={[{ name: 'Guides' }]} /></div>
        <Badge className="mb-4 bg-orange-500 hover:bg-orange-600"><BookOpen className="h-3.5 w-3.5 mr-1" /> Free guides</Badge>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4">Motorhome Touring Guides</h1>
        <p className="text-lg md:text-xl text-slate-300 max-w-3xl">Routes, campsites and honest advice from a family that hires motorhomes in Suffolk every week of the year.</p>
      </div>
    </section>
    <section className="py-14">
      <div className="max-w-7xl mx-auto px-4 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {guides.map((g) => (
          <Card key={g.slug} className="overflow-hidden hover:shadow-xl transition-shadow group" data-testid={`guide-card-${g.slug}`}>
            <Link to={`/guides/${g.slug}`}>
              <img src={g.image} alt={g.title} className="h-52 w-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
            </Link>
            <CardContent className="p-6">
              <div className="flex items-center gap-3 text-xs text-slate-500 mb-3"><Badge variant="secondary">{g.category}</Badge><span className="flex items-center gap-1"><Clock className="h-3 w-3" />{g.readTime}</span></div>
              <h2 className="text-lg font-bold text-slate-900 mb-2"><Link to={`/guides/${g.slug}`} className="hover:text-blue-700">{g.title}</Link></h2>
              <p className="text-sm text-slate-600 mb-4">{g.excerpt}</p>
              <Link to={`/guides/${g.slug}`} className="text-sm font-semibold text-blue-700 flex items-center gap-1">Read guide <ArrowRight className="h-4 w-4" /></Link>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  </div>
);

export default Guides;
